<template>
  <SelectChatWrapper
    :lists-container-height="listsContainerHeight"
    :lists="lists"
    :is-recommendations-visible="isRecommendationsVisible"
    :selected-members="selectedGroupMembers"
    :title="$t('chat.chatSidebar.EditChatPreview.title')"
    :confirm-title="$t('settings.chat.editGroupChat.save')"
    @add-selected="handleAddGroupMember"
    @remove-selected="handleRemoveGroupMember"
    @redirect="handleRedirect"
    @confirm="handleSaveAddedMembers"
  />
</template>
<script setup lang="ts">
import { useGetEditChatMobileContainerProperties } from "./useGetEditChatMobileContainerProperties";
import SelectChatWrapper from "../SelectChatWrapper/SelectChatWrapper.vue";

const {
  listsContainerHeight,
  lists,
  handleRedirect,
  selectedGroupMembers,
  handleAddGroupMember,
  handleRemoveGroupMember,
  handleSaveAddedMembers,
  isRecommendationsVisible,
} = useGetEditChatMobileContainerProperties();
</script>
